module.exports = __webpack_public_path__ + "media/images/emblems/Grandevent-coat_of_arms-0fd7a3606d632dac030757c33de0c0ec.svg";